import { getVersionIcon } from "../../helpers/utils";

export const images = {
    "refill": getVersionIcon("categories/phones.png"),
    "recargar": getVersionIcon("categories/phones.png"),
    "devices": getVersionIcon("categories/hotspot-nav-image.png"),
    "dispositivos": getVersionIcon("categories/hotspot-nav-image.png"),
    "more options": getVersionIcon("categories/generic-phone-kyop-nav.png"),
    "más opciones": getVersionIcon("categories/generic-phone-kyop-nav.png"),
    "handset protection": getVersionIcon("categories/generic-phone-HPP-nav.png"),
    "protección del teléfono": getVersionIcon("categories/generic-phone-HPP-nav.png"),
    "deals": getVersionIcon("categories/deals-nav-image.png"),
    "ofertas": getVersionIcon("categories/deals-nav-image.png"),
    "phones": getVersionIcon("categories/all-phones-nav-image.png"),
    "teléfonos": getVersionIcon("categories/all-phones-nav-image.png"),
    "accessories": getVersionIcon("categories/accessories-nav-image.png"),
    "accesorios": getVersionIcon("categories/accessories-nav-image.png"),
    "service plans": getVersionIcon("categories/service-plans-nav.webp"),
    "planes de servicio": getVersionIcon("categories/service-plans-nav.webp"),
    "device plans": getVersionIcon("categories/device_service_nav_image.webp"),
    "planes para dispositivos": getVersionIcon("categories/device_service_nav_image.webp"),
    "straight talk extras": getVersionIcon("categories/vas-nav-image.webp"),
    "sim & keep your own device": getVersionIcon("categories/phones.png"),
    "sim y quédate con tu propio dispositivo": getVersionIcon("categories/phones.png")
}



// WEBPACK FOOTER //
// ./src/components/Navbar/images.js